import Image from "../../../ui/widgets/image";
import pdfSuccessSvg from "../../../resources/images/scd-pdf-success.svg";
import { FC, MouseEventHandler } from "react";
import { AttachmentMetaDocument } from "../../../api/commercial/generated-types";
import CustomLink from "../../../ui/widgets/link";
import { useStopBubbling } from "../../../ui/widgets";

interface SuccessUploaderProps {
  handleOnClickRemoveFile: MouseEventHandler;
  uploadedFile: AttachmentMetaDocument;
}

const classNameBase = "scd-upload";

const SuccessUploader: FC<SuccessUploaderProps> = ({
  handleOnClickRemoveFile,
  uploadedFile,
}: SuccessUploaderProps) => {
  const stopBubbling = useStopBubbling();
  return (
    <>
      <div className={`${classNameBase}-image`}>
        <Image src={pdfSuccessSvg} />
      </div>
      <div className={`${classNameBase}-file-wrapper`}>
        <i
          className={`${classNameBase}-file-remove icon-scd-subtract`}
          onClick={handleOnClickRemoveFile}
        />

        {uploadedFile.applicationRef && (
          <CustomLink
            className={`${classNameBase}-file-name`}
            href={`/commercial/api/protected/application/${uploadedFile.applicationRef.uuid}/attachment/${uploadedFile.uuid}/`}
            target="_blank"
            rel="noopener noreferrer"
            noicon
            onClick={stopBubbling}
          >
            {uploadedFile.customersFileName}
          </CustomLink>
        )}
      </div>
    </>
  );
};

export default SuccessUploader;
